import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useApp } from "../context";

export const Navigation = observer(function Navigation() {
  const app = useApp();
  const { t } = useTranslation();

  // TODO: Check auth/permission

  if (app.parse.user?.isAdmin) {
    return (
      <>
        <Link to="admin">{t("nav-admin")}</Link>
        <Link to="logout">{t("nav-logout")}</Link>
      </>
    );
  }

  if (app.parse.user) {
    return (
      <>
        <Link to="benchmark">{t("nav-benchmark")}</Link>
        <Link to="logout">{t("nav-logout")}</Link>
      </>
    );
  }

  return (
    <>
      <a
        href="https://antiscam-project.de/"
        title={t("nav-to-project-page-title")}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("nav-to-project-page")}
      </a>
      {/* <Link to="benchmark">{t("nav-benchmark")}</Link>
      <Link to="login">{t("nav-login")}</Link> */}
    </>
  );
});
